export declare namespace ReportStatusTagTokenSections {
	interface Completed {
		background: string;
		color: string;
	}
}

export type ReportStatusTagTokens = {
	completed: ReportStatusTagTokenSections.Completed;
};

export const completed: ReportStatusTagTokenSections.Completed = {
	background: '{reportCompleted.background}',
	color: '{reportCompleted.color}',
};

export default {
	completed,
} satisfies ReportStatusTagTokens;
